
// import React, { useState, useEffect } from 'react';
// import { 
//     Dropdown, 
//     Badge, 
//     Button, 
//     List, 
//     Empty, 
//     Spin, 
//     Typography, 
//     message,
//     Tooltip,
//     Switch,
//     Space
// } from 'antd';
// import {
//     BellOutlined,
//     CheckOutlined,
//     ReloadOutlined,
//     ExperimentOutlined,
//     EyeOutlined
// } from '@ant-design/icons';
// import courseService from "../../services/course.service";

// const { Text } = Typography;

// const NotificationDropdown = ({ currentUser }) => {
//     const [notifications, setNotifications] = useState([]);
//     const [unreadCount, setUnreadCount] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [showReadNotifications, setShowReadNotifications] = useState(false); // Nouveau state

//     useEffect(() => {
//         if (currentUser) {
//             loadNotifications();
//             loadUnreadCount();
            
//             const interval = setInterval(() => {
//                 loadUnreadCount();
//             }, 60000);

//             return () => clearInterval(interval);
//         }
//     }, [currentUser]);

//     const loadNotifications = async () => {
//         try {
//             setLoading(true);
//             const data = await courseService.getMyNotifications();
//             setNotifications(data || []);
//         } catch (error) {
//             console.error('Erreur chargement notifications:', error);
//             message.error('Erreur lors du chargement des notifications');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const loadUnreadCount = async () => {
//         try {
//             const data = await courseService.getUnreadNotificationsCount();
//             setUnreadCount(data.count || 0);
//         } catch (error) {
//             console.error('Erreur comptage notifications:', error);
//         }
//     };

//     const handleMarkAsRead = async (notificationId, event) => {
//         event.stopPropagation();
        
//         try {
//             await courseService.markNotificationAsRead(notificationId);
            
//             setNotifications(prev => 
//                 prev.map(notif => 
//                     notif.id === notificationId 
//                         ? { ...notif, isRead: true, readAt: new Date().toISOString() }
//                         : notif
//                 )
//             );
            
//             setUnreadCount(prev => Math.max(0, prev - 1));
//             message.success('Notification marquée comme lue');
//         } catch (error) {
//             console.error('Erreur marquage notification:', error);
//             message.error('Erreur lors du marquage');
//         }
//     };

//     const handleMarkAllAsRead = async () => {
//         try {
//             await courseService.markAllNotificationsAsRead();
            
//             setNotifications(prev => 
//                 prev.map(notif => ({ 
//                     ...notif, 
//                     isRead: true, 
//                     readAt: new Date().toISOString() 
//                 }))
//             );
            
//             setUnreadCount(0);
//             message.success('Toutes les notifications marquées comme lues');
//         } catch (error) {
//             console.error('Erreur marquage toutes notifications:', error);
//             message.error('Erreur lors du marquage');
//         }
//     };

//     const handleCreateTest = async () => {
//         try {
//             await courseService.createTestNotification();
//             message.success('Notification de test créée');
//             await loadNotifications();
//             await loadUnreadCount();
//         } catch (error) {
//             console.error('Erreur création test:', error);
//             message.error('Erreur lors de la création du test');
//         }
//     };

//     const handleRefresh = async () => {
//         await loadNotifications();
//         await loadUnreadCount();
//         message.success('Notifications actualisées');
//     };

//     // NOUVEAU : Filtrage des notifications selon le toggle
//     const filteredNotifications = showReadNotifications 
//         ? notifications 
//         : notifications.filter(notif => !notif.isRead);

//     const formatNotificationDate = (dateString) => {
//         const date = new Date(dateString);
//         const now = new Date();
//         const diffInMs = now - date;
//         const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
//         const diffInHours = Math.floor(diffInMinutes / 60);
//         const diffInDays = Math.floor(diffInHours / 24);

//         if (diffInMinutes < 1) return 'À l\'instant';
//         if (diffInMinutes < 60) return `Il y a ${diffInMinutes}min`;
//         if (diffInHours < 24) return `Il y a ${diffInHours}h`;
//         if (diffInDays < 7) return `Il y a ${diffInDays}j`;
        
//         return date.toLocaleDateString('fr-FR', {
//             day: '2-digit',
//             month: '2-digit',
//             year: '2-digit'
//         });
//     };

//     const getNotificationIcon = (type) => {
//         const iconMap = {
//             EMAIL_SENT: '📧',
//             COURSE_CREATED: '🆕',
//             COURSE_PURCHASED: '💰',
//             SALES_REQUEST: '📋',
//             INSTRUCTOR_REQUEST: '👨‍🏫',
//             PLAN_PURCHASED: '💎',
//             PAYMENT_RECEIVED: '💳',
//             CERTIFICATE_GENERATED: '🎓',
//             USER_REGISTERED: '👋',
//             SYSTEM_ALERT: '⚠️'
//         };
        
//         return iconMap[type] || '📢';
//     };

//     const getNotificationColor = (type, isRead) => {
//         if (isRead) return '#f0f0f0';
        
//         const colorMap = {
//             EMAIL_SENT: '#1890ff',
//             COURSE_CREATED: '#52c41a',
//             COURSE_PURCHASED: '#faad14',
//             SALES_REQUEST: '#722ed1',
//             INSTRUCTOR_REQUEST: '#13c2c2',
//             PLAN_PURCHASED: '#eb2f96',
//             PAYMENT_RECEIVED: '#52c41a',
//             CERTIFICATE_GENERATED: '#1890ff',
//             USER_REGISTERED: '#52c41a',
//             SYSTEM_ALERT: '#ff4d4f'
//         };
        
//         return colorMap[type] || '#1890ff';
//     };

//     const renderNotificationItem = (notification) => (
//         <List.Item
//             key={notification.id}
//             style={{
//                 padding: '12px 16px',
//                 backgroundColor: notification.isRead ? '#fafafa' : '#fff',
//                 borderLeft: `4px solid ${getNotificationColor(notification.type, notification.isRead)}`,
//                 margin: '4px 0',
//                 borderRadius: '4px',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease'
//             }}
//             onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = '#f0f2ff';
//             }}
//             onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = notification.isRead ? '#fafafa' : '#fff';
//             }}
//             actions={[
//                 !notification.isRead && (
//                     <Tooltip title="Marquer comme lu">
//                         <Button
//                             type="text"
//                             size="small"
//                             icon={<CheckOutlined />}
//                             onClick={(e) => handleMarkAsRead(notification.id, e)}
//                             style={{ color: '#52c41a' }}
//                         />
//                     </Tooltip>
//                 )
//             ].filter(Boolean)}
//         >
//             <List.Item.Meta
//                 avatar={
//                     <span style={{ fontSize: '20px' }}>
//                         {getNotificationIcon(notification.type)}
//                     </span>
//                 }
//                 title={
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Text strong={!notification.isRead} style={{ fontSize: '14px' }}>
//                             {notification.title}
//                         </Text>
//                         <Text type="secondary" style={{ fontSize: '11px' }}>
//                             {formatNotificationDate(notification.createdAt)}
//                         </Text>
//                     </div>
//                 }
//                 description={
//                     <Text 
//                         style={{ 
//                             fontSize: '12px', 
//                             color: notification.isRead ? '#8c8c8c' : '#595959',
//                             display: '-webkit-box',
//                             WebkitLineClamp: 2,
//                             WebkitBoxOrient: 'vertical',
//                             overflow: 'hidden'
//                         }}
//                     >
//                         {notification.message}
//                     </Text>
//                 }
//             />
//         </List.Item>
//     );

//     const dropdownContent = (
//         <div style={{ 
//             width: '380px', 
//             maxHeight: '500px', 
//             backgroundColor: '#fff',
//             borderRadius: '8px',
//             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
//         }}>
//             {/* En-tête avec toggle */}
//             <div style={{ 
//                 padding: '16px', 
//                 borderBottom: '1px solid #f0f0f0',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center'
//             }}>
//                 <Text strong style={{ fontSize: '16px' }}>
//                     Notifications {unreadCount > 0 && `(${unreadCount} non lues)`}
//                 </Text>
//                 <div style={{ display: 'flex', gap: '8px' }}>
//                     <Tooltip title="Actualiser">
//                         <Button 
//                             type="text" 
//                             size="small" 
//                             icon={<ReloadOutlined />}
//                             onClick={handleRefresh}
//                         />
//                     </Tooltip>
//                     {process.env.NODE_ENV === 'development' && (
//                         <Tooltip title="Test (dev)">
//                             <Button 
//                                 type="text" 
//                                 size="small" 
//                                 icon={<ExperimentOutlined />}
//                                 onClick={handleCreateTest}
//                             />
//                         </Tooltip>
//                     )}
//                     {unreadCount > 0 && (
//                         <Tooltip title="Tout marquer comme lu">
//                             <Button 
//                                 type="text" 
//                                 size="small" 
//                                 icon={<CheckOutlined />}
//                                 onClick={handleMarkAllAsRead}
//                                 style={{ color: '#52c41a' }}
//                             />
//                         </Tooltip>
//                     )}
//                 </div>
//             </div>

//             {/* NOUVEAU : Toggle pour afficher/masquer les notifications lues */}
//             <div style={{ 
//                 padding: '8px 16px', 
//                 borderBottom: '1px solid #f0f0f0',
//                 backgroundColor: '#fafafa'
//             }}>
//                 <Space>
//                     <EyeOutlined style={{ color: '#666' }} />
//                     <Text style={{ fontSize: '12px' }}>Afficher les notifications lues</Text>
//                     <Switch 
//                         size="small" 
//                         checked={showReadNotifications}
//                         onChange={setShowReadNotifications}
//                     />
//                 </Space>
//             </div>

//             {/* Contenu des notifications avec filtrage */}
//             <div style={{ 
//                 maxHeight: '350px', 
//                 overflowY: 'auto',
//                 padding: '8px'
//             }}>
//                 {loading ? (
//                     <div style={{ textAlign: 'center', padding: '40px' }}>
//                         <Spin size="large" />
//                         <div style={{ marginTop: '12px' }}>
//                             <Text type="secondary">Chargement...</Text>
//                         </div>
//                     </div>
//                 ) : filteredNotifications.length === 0 ? (
//                     <Empty
//                         image={Empty.PRESENTED_IMAGE_SIMPLE}
//                         description={
//                             showReadNotifications 
//                                 ? "Aucune notification" 
//                                 : "Aucune notification non lue"
//                         }
//                         style={{ padding: '40px 20px' }}
//                     />
//                 ) : (
//                     <List
//                         dataSource={filteredNotifications.slice(0, 10)}
//                         renderItem={renderNotificationItem}
//                         split={false}
//                     />
//                 )}
//             </div>

//             {/* Pied de page avec compteur */}
//             {filteredNotifications.length > 10 && (
//                 <div style={{ 
//                     padding: '12px 16px', 
//                     borderTop: '1px solid #f0f0f0',
//                     textAlign: 'center'
//                 }}>
//                     <Button type="link" size="small">
//                         Voir toutes les notifications ({filteredNotifications.length})
//                     </Button>
//                 </div>
//             )}
//         </div>
//     );

//     if (!currentUser) {
//         return null;
//     }

//     return (
//         <Dropdown
//             overlay={dropdownContent}
//             trigger={['click']}
//             placement="bottomRight"
//             visible={dropdownVisible}
//             onVisibleChange={setDropdownVisible}
//         >
//             <Badge count={unreadCount} size="small" offset={[-2, 2]}>
//                 <Button
//                     icon={<BellOutlined />}
//                     type="text"
//                     size="middle"
//                     style={{
//                         color: 'white',
//                         background: 'rgba(255, 255, 255, 0.1)',
//                         border: '1px solid rgba(255, 255, 255, 0.2)',
//                         borderRadius: '50%',
//                         width: '40px',
//                         height: '40px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center'
//                     }}
//                 />
//             </Badge>
//         </Dropdown>
//     );
// };

// export default NotificationDropdown;


// NotificationDropdown.js - Version avec Modal pour les détails

import React, { useState, useEffect } from 'react';
import { 
    Dropdown, 
    Badge, 
    Button, 
    List, 
    Empty, 
    Spin, 
    Typography, 
    message,
    Tooltip,
    Switch,
    Space,
    Modal,
    Divider,
    Tag
} from 'antd';
import {
    BellOutlined,
    CheckOutlined,
    ReloadOutlined,
    ExperimentOutlined,
    EyeOutlined,
    InfoCircleOutlined,
    CloseOutlined
} from '@ant-design/icons';
import courseService from "../../services/course.service";

const { Text, Paragraph, Title } = Typography;

const NotificationDropdown = ({ currentUser }) => {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showReadNotifications, setShowReadNotifications] = useState(false);
    
    // États pour la modal
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);

    useEffect(() => {
        if (currentUser) {
            loadNotifications();
            loadUnreadCount();
            
            const interval = setInterval(() => {
                loadUnreadCount();
            }, 60000);

            return () => clearInterval(interval);
        }
    }, [currentUser]);

    const loadNotifications = async () => {
        try {
            setLoading(true);
            const data = await courseService.getMyNotifications();
            setNotifications(data || []);
        } catch (error) {
            console.error('Erreur chargement notifications:', error);
            message.error('Erreur lors du chargement des notifications');
        } finally {
            setLoading(false);
        }
    };

    const loadUnreadCount = async () => {
        try {
            const data = await courseService.getUnreadNotificationsCount();
            setUnreadCount(data.count || 0);
        } catch (error) {
            console.error('Erreur comptage notifications:', error);
        }
    };

    const handleMarkAsRead = async (notificationId, event) => {
        event.stopPropagation();
        
        try {
            await courseService.markNotificationAsRead(notificationId);
            
            setNotifications(prev => 
                prev.map(notif => 
                    notif.id === notificationId 
                        ? { ...notif, isRead: true, readAt: new Date().toISOString() }
                        : notif
                )
            );
            
            setUnreadCount(prev => Math.max(0, prev - 1));
            message.success('Notification marquée comme lue');
        } catch (error) {
            console.error('Erreur marquage notification:', error);
            message.error('Erreur lors du marquage');
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            await courseService.markAllNotificationsAsRead();
            
            setNotifications(prev => 
                prev.map(notif => ({ 
                    ...notif, 
                    isRead: true, 
                    readAt: new Date().toISOString() 
                }))
            );
            
            setUnreadCount(0);
            message.success('Toutes les notifications marquées comme lues');
        } catch (error) {
            console.error('Erreur marquage toutes notifications:', error);
            message.error('Erreur lors du marquage');
        }
    };

    const handleCreateTest = async () => {
        try {
            await courseService.createTestNotification();
            message.success('Notification de test créée');
            await loadNotifications();
            await loadUnreadCount();
        } catch (error) {
            console.error('Erreur création test:', error);
            message.error('Erreur lors de la création du test');
        }
    };

    const handleRefresh = async () => {
        await loadNotifications();
        await loadUnreadCount();
        message.success('Notifications actualisées');
    };

    // Nouvelle fonction pour ouvrir la modal avec les détails
    const handleViewDetails = (notification, event) => {
        event.stopPropagation();
        setSelectedNotification(notification);
        setModalVisible(true);
        setDropdownVisible(false); // Fermer le dropdown
    };

    // Nouvelle fonction pour marquer comme lu depuis la modal
    const handleMarkAsReadFromModal = async () => {
        if (selectedNotification && !selectedNotification.isRead) {
            try {
                await courseService.markNotificationAsRead(selectedNotification.id);
                
                setNotifications(prev => 
                    prev.map(notif => 
                        notif.id === selectedNotification.id 
                            ? { ...notif, isRead: true, readAt: new Date().toISOString() }
                            : notif
                    )
                );
                
                setSelectedNotification(prev => ({
                    ...prev,
                    isRead: true,
                    readAt: new Date().toISOString()
                }));
                
                setUnreadCount(prev => Math.max(0, prev - 1));
                message.success('Notification marquée comme lue');
            } catch (error) {
                console.error('Erreur marquage notification:', error);
                message.error('Erreur lors du marquage');
            }
        }
    };

    const filteredNotifications = showReadNotifications 
        ? notifications 
        : notifications.filter(notif => !notif.isRead);

    const formatNotificationDate = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInMs = now - date;
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInMinutes < 1) return 'À l\'instant';
        if (diffInMinutes < 60) return `Il y a ${diffInMinutes}min`;
        if (diffInHours < 24) return `Il y a ${diffInHours}h`;
        if (diffInDays < 7) return `Il y a ${diffInDays}j`;
        
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
        });
    };

    const formatFullDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getNotificationIcon = (type) => {
        const iconMap = {
            EMAIL_SENT: '📧',
            COURSE_CREATED: '🆕',
            COURSE_PURCHASED: '💰',
            SALES_REQUEST: '📋',
            INSTRUCTOR_REQUEST: '👨‍🏫',
            PLAN_PURCHASED: '💎',
            PAYMENT_RECEIVED: '💳',
            CERTIFICATE_GENERATED: '🎓',
            USER_REGISTERED: '👋',
            SYSTEM_ALERT: '⚠️'
        };
        
        return iconMap[type] || '📢';
    };

    const getNotificationColor = (type, isRead) => {
        if (isRead) return '#f0f0f0';
        
        const colorMap = {
            EMAIL_SENT: '#1890ff',
            COURSE_CREATED: '#52c41a',
            COURSE_PURCHASED: '#faad14',
            SALES_REQUEST: '#722ed1',
            INSTRUCTOR_REQUEST: '#13c2c2',
            PLAN_PURCHASED: '#eb2f96',
            PAYMENT_RECEIVED: '#52c41a',
            CERTIFICATE_GENERATED: '#1890ff',
            USER_REGISTERED: '#52c41a',
            SYSTEM_ALERT: '#ff4d4f'
        };
        
        return colorMap[type] || '#1890ff';
    };

    const getTypeLabel = (type) => {
        const typeLabels = {
            EMAIL_SENT: 'Email envoyé',
            COURSE_CREATED: 'Nouveau cours',
            COURSE_PURCHASED: 'Achat de cours',
            SALES_REQUEST: 'Demande commerciale',
            INSTRUCTOR_REQUEST: 'Candidature instructeur',
            PLAN_PURCHASED: 'Plan acheté',
            PAYMENT_RECEIVED: 'Paiement reçu',
            CERTIFICATE_GENERATED: 'Certificat généré',
            USER_REGISTERED: 'Nouvel utilisateur',
            SYSTEM_ALERT: 'Alerte système'
        };
        
        return typeLabels[type] || type;
    };

    const renderNotificationItem = (notification) => (
        <List.Item
            key={notification.id}
            style={{
                padding: '12px 16px',
                backgroundColor: notification.isRead ? '#fafafa' : '#fff',
                borderLeft: `4px solid ${getNotificationColor(notification.type, notification.isRead)}`,
                margin: '4px 0',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f2ff';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = notification.isRead ? '#fafafa' : '#fff';
            }}
            onClick={(e) => handleViewDetails(notification, e)}
            actions={[
                <Tooltip title="Voir les détails">
                    <Button
                        type="text"
                        size="small"
                        icon={<InfoCircleOutlined />}
                        onClick={(e) => handleViewDetails(notification, e)}
                        style={{ color: '#1890ff' }}
                    />
                </Tooltip>,
                !notification.isRead && (
                    <Tooltip title="Marquer comme lu">
                        <Button
                            type="text"
                            size="small"
                            icon={<CheckOutlined />}
                            onClick={(e) => handleMarkAsRead(notification.id, e)}
                            style={{ color: '#52c41a' }}
                        />
                    </Tooltip>
                )
            ].filter(Boolean)}
        >
            <List.Item.Meta
                avatar={
                    <span style={{ fontSize: '20px' }}>
                        {getNotificationIcon(notification.type)}
                    </span>
                }
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text strong={!notification.isRead} style={{ fontSize: '14px' }}>
                            {notification.title}
                        </Text>
                        <Text type="secondary" style={{ fontSize: '11px' }}>
                            {formatNotificationDate(notification.createdAt)}
                        </Text>
                    </div>
                }
                description={
                    <Text 
                        style={{ 
                            fontSize: '12px', 
                            color: notification.isRead ? '#8c8c8c' : '#595959',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}
                    >
                        {notification.message}
                    </Text>
                }
            />
        </List.Item>
    );

    const dropdownContent = (
        <div style={{ 
            width: '380px', 
            maxHeight: '500px', 
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
        }}>
            {/* En-tête */}
            <div style={{ 
                padding: '16px', 
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Text strong style={{ fontSize: '16px' }}>
                    Notifications {unreadCount > 0 && `(${unreadCount} non lues)`}
                </Text>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Tooltip title="Actualiser">
                        <Button 
                            type="text" 
                            size="small" 
                            icon={<ReloadOutlined />}
                            onClick={handleRefresh}
                        />
                    </Tooltip>
                    {process.env.NODE_ENV === 'development' && (
                        <Tooltip title="Test (dev)">
                            <Button 
                                type="text" 
                                size="small" 
                                icon={<ExperimentOutlined />}
                                onClick={handleCreateTest}
                            />
                        </Tooltip>
                    )}
                    {unreadCount > 0 && (
                        <Tooltip title="Tout marquer comme lu">
                            <Button 
                                type="text" 
                                size="small" 
                                icon={<CheckOutlined />}
                                onClick={handleMarkAllAsRead}
                                style={{ color: '#52c41a' }}
                            />
                        </Tooltip>
                    )}
                </div>
            </div>

            {/* Toggle pour afficher/masquer les notifications lues */}
            <div style={{ 
                padding: '8px 16px', 
                borderBottom: '1px solid #f0f0f0',
                backgroundColor: '#fafafa'
            }}>
                <Space>
                    <EyeOutlined style={{ color: '#666' }} />
                    <Text style={{ fontSize: '12px' }}>Afficher les notifications lues</Text>
                    <Switch 
                        size="small" 
                        checked={showReadNotifications}
                        onChange={setShowReadNotifications}
                    />
                </Space>
            </div>

            {/* Contenu des notifications */}
            <div style={{ 
                maxHeight: '350px', 
                overflowY: 'auto',
                padding: '8px'
            }}>
                {loading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <Spin size="large" />
                        <div style={{ marginTop: '12px' }}>
                            <Text type="secondary">Chargement...</Text>
                        </div>
                    </div>
                ) : filteredNotifications.length === 0 ? (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            showReadNotifications 
                                ? "Aucune notification" 
                                : "Aucune notification non lue"
                        }
                        style={{ padding: '40px 20px' }}
                    />
                ) : (
                    <List
                        dataSource={filteredNotifications.slice(0, 10)}
                        renderItem={renderNotificationItem}
                        split={false}
                    />
                )}
            </div>

            {/* Pied de page */}
            {filteredNotifications.length > 10 && (
                <div style={{ 
                    padding: '12px 16px', 
                    borderTop: '1px solid #f0f0f0',
                    textAlign: 'center'
                }}>
                    <Button type="link" size="small">
                        Voir toutes les notifications ({filteredNotifications.length})
                    </Button>
                </div>
            )}
        </div>
    );

    if (!currentUser) {
        return null;
    }

    return (
        <>
            <Dropdown
                overlay={dropdownContent}
                trigger={['click']}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={setDropdownVisible}
            >
                <Badge count={unreadCount} size="small" offset={[-2, 2]}>
                    <Button
                        icon={<BellOutlined />}
                        type="text"
                        size="middle"
                        style={{
                            color: 'white',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    />
                </Badge>
            </Dropdown>

            {/* Modal pour les détails de la notification */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontSize: '24px' }}>
                            {selectedNotification && getNotificationIcon(selectedNotification.type)}
                        </span>
                        <div>
                            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                Détails de la notification
                            </div>
                            {selectedNotification && (
                                <Tag 
                                    color={getNotificationColor(selectedNotification.type, false)}
                                    style={{ margin: '4px 0 0 0' }}
                                >
                                    {getTypeLabel(selectedNotification.type)}
                                </Tag>
                            )}
                        </div>
                    </div>
                }
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                width={600}
                footer={[
                    selectedNotification && !selectedNotification.isRead && (
                        <Button 
                            key="mark-read"
                            type="primary"
                            icon={<CheckOutlined />}
                            onClick={handleMarkAsReadFromModal}
                        >
                            Marquer comme lue
                        </Button>
                    ),
                    <Button 
                        key="close" 
                        onClick={() => setModalVisible(false)}
                        icon={<CloseOutlined />}
                    >
                        Fermer
                    </Button>
                ].filter(Boolean)}
            >
                {selectedNotification && (
                    <div style={{ padding: '8px 0' }}>
                        {/* Titre et statut */}
                        <div style={{ marginBottom: '16px' }}>
                            <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                                {selectedNotification.title}
                            </Title>
                            <div style={{ marginTop: '8px' }}>
                                {selectedNotification.isRead ? (
                                    <Tag color="success">
                                        <CheckOutlined /> Lue le {formatFullDate(selectedNotification.readAt)}
                                    </Tag>
                                ) : (
                                    <Tag color="warning">
                                        Non lue
                                    </Tag>
                                )}
                            </div>
                        </div>

                        <Divider />

                        {/* Contenu principal */}
                        <div style={{ marginBottom: '16px' }}>
                            <Text strong style={{ fontSize: '14px', color: '#666' }}>
                                Message :
                            </Text>
                            <Paragraph style={{ 
                                marginTop: '8px', 
                                fontSize: '14px',
                                background: '#f9f9f9',
                                padding: '12px',
                                borderRadius: '6px',
                                borderLeft: `4px solid ${getNotificationColor(selectedNotification.type, false)}`
                            }}>
                                {selectedNotification.message}
                            </Paragraph>
                        </div>

                        {/* Métadonnées */}
                        {selectedNotification.metadata && (
                            <div style={{ marginBottom: '16px' }}>
                                <Text strong style={{ fontSize: '14px', color: '#666' }}>
                                    Informations supplémentaires :
                                </Text>
                                <div style={{ 
                                    marginTop: '8px',
                                    background: '#f0f2ff',
                                    padding: '12px',
                                    borderRadius: '6px',
                                    border: '1px solid #d9d9d9'
                                }}>
                                    <pre style={{ 
                                        fontFamily: 'Monaco, monospace',
                                        fontSize: '12px',
                                        margin: 0,
                                        whiteSpace: 'pre-wrap'
                                    }}>
                                        {JSON.stringify(JSON.parse(selectedNotification.metadata), null, 2)}
                                    </pre>
                                </div>
                            </div>
                        )}

                        <Divider />

                        {/* Informations temporelles */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    Créée le : {formatFullDate(selectedNotification.createdAt)}
                                </Text>
                            </div>
                            <div>
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    ID : {selectedNotification.id}
                                </Text>
                            </div>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
};

export default NotificationDropdown;